export function splitTime(time?: string): { hours: number; minutes: number } | undefined {
  if (!time?.trim()) return undefined;

  const split = time.split(":");
  const hours = parseInt(split[0]);
  const minutes = parseInt(split[1]);

  return { hours, minutes };
}
